import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { Layout, Spin } from "antd";
import { ErrorBoundary } from "components";
import routes from "config/routes";
const AntContent = Layout.Content;

const Content = () => {
  return (
    <AntContent>
      <Suspense fallback={<Spin />}>
        <ErrorBoundary>{useRoutes(routes)}</ErrorBoundary>
      </Suspense>
    </AntContent>
  );
};

export default Content;
